import {
  ISOLVED_CONNECTION_NAME,
  IsolvedAuthParamKeys,
  IsolvedParamKeys,
} from '@/types/queryParamKeys';

/**
 * Builds the Auth0 authorizationParams to forward for an isolved SSO login
 * @param search - The URL search string to read the isolved params from
 * @returns connection + present isolved params, or {} for non-isolved connections
 */
export const getIsolvedAuthorizationParams = (
  search: string
): Record<string, string> => {
  const params = new URLSearchParams(search);

  if (params.get('connection') !== ISOLVED_CONNECTION_NAME) {
    return {};
  }

  const tenantId = params.get(IsolvedParamKeys.TenantId);
  const clientId = params.get(IsolvedParamKeys.ClientId);
  const globalId = params.get(IsolvedParamKeys.GlobalId);

  return {
    connection: ISOLVED_CONNECTION_NAME,
    ...(tenantId && { [IsolvedAuthParamKeys.TenantId]: tenantId }),
    ...(clientId && { [IsolvedAuthParamKeys.ClientId]: clientId }),
    ...(globalId && { [IsolvedAuthParamKeys.GlobalId]: globalId }),
  };
};
